import { createRef, RefObject, useRef, useState } from "react";
import { FieldGroup } from "../../../form/FieldGroup";
import { FormValidationResult } from "../../../form/formValidation";
import { Flex, InputText } from "../../../ui-components";

export const CONFIRMATION_CODE_SIZE = 6;

interface Props {
  errors: FormValidationResult;
  onSubmit: (code: string) => void;
  isLoading: boolean;
  label?: string;
}

export const ConfirmationCodeForm: React.FC<Props> = ({ errors: error, onSubmit, isLoading, label }) => {
  const [code, setCode] = useState(Array(CONFIRMATION_CODE_SIZE).fill(""));

  const lineRefs = useRef<RefObject<HTMLInputElement>[]>([]);
  lineRefs.current = code.map((_, i) => lineRefs.current[i] ?? createRef());

  return (
    <FieldGroup label={label ?? ""} validation={error} fill>
      <Flex direction="row" gap={4}>
        {code.map((char, i) => {
          const applyChange = (change: string) => {
            if (change !== "" && change !== `${Number(change)}`) {
              return; // not a number
            }

            const offsetToSliceOf = change.length < 1 ? 1 : change.length;

            const newCode = [
              ...code.slice(0, i),
              ...(change.length > 0 ? change.split("") : [""]),
              ...code.slice(i + offsetToSliceOf),
            ].slice(0, CONFIRMATION_CODE_SIZE);

            lineRefs.current[i + change.length]?.current?.focus();

            setCode(newCode);
            if (newCode.every((it) => it.length > 0)) {
              onSubmit(newCode.join(""));
            }
          };

          return (
            <InputText
              style={{ width: "40px" }}
              key={`confirmationCode${i}`}
              autoComplete="off"
              id={`confirmationCode${i}`}
              disabled={isLoading}
              type="number"
              value={char}
              onPaste={(e) => {
                const change = e.clipboardData.getData("Text");
                applyChange(change);
              }}
              setValue={(change) => {
                // this will prevent fire after onPaste
                if (change.length > 1) {
                  return;
                }

                applyChange(change.slice(0, 1));
              }}
              border={"neutral"}
              required={true}
              ref={lineRefs.current[i]}
            />
          );
        })}
      </Flex>
    </FieldGroup>
  );
};
